<mat-form-field class="library-status-filter input filter">
  <mat-select [(value)]="value" (selectionChange)="changed(value)">
    <mat-option [value]="option.value" *ngFor="let option of libraryStatusList">
      {{ 'libraries.configurationStatusFilter.' + option.value | translate }}
    </mat-option>
  </mat-select>
</mat-form-field>
